import axios from "axios";

var baseURL = "https://loc.slim.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.slim.de"
) {
  baseURL = "https://loc.slim.de";
}

if (window.location.hostname == "www.slim.de") {
  baseURL = "https://www.slim.de";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
